export var DEFAULT_NAMESPACE = '/';
export var ACTION_TYPE_DELIMITER = '||';


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/constants.js
// module id = 180
// module chunks = 1